import { Suspense, lazy, useEffect, useState } from 'react';

/**
 * T2908: globalno iskanje vleče cmdk in dialog; lupina ga ne sme imeti v vstopnem grafu.
 * Kos se naloži (1) ob hoverju/fokusu iskalnega gumba (`preloadGlobalSearch`), (2) ob
 * nedejavnosti po prvem izrisu in (3) najpozneje ob prvem odprtju — odprtje namesti okno
 * takoj, ko je kos tu, klik se ne izgubi (stanje `open` drži lupina). Okno je portal, zato
 * ob nalaganju ni skoka postavitve.
 */
const loadDialog = () => import('./GlobalSearchDialog');
const GlobalSearchDialog = lazy(loadDialog);

/** Predhodno nalaganje; varno klicati večkrat. */
export function preloadGlobalSearch(): void {
  void loadDialog();
}

interface Props {
  open: boolean;
  onClose: () => void;
  organizationId?: number;
}

export default function LazyGlobalSearchDialog({ open, onClose, organizationId }: Props) {
  const [everOpened, setEverOpened] = useState(open);

  useEffect(() => {
    if (open) setEverOpened(true);
  }, [open]);

  useEffect(() => {
    const w = window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
      cancelIdleCallback?: (id: number) => void;
    };
    if (w.requestIdleCallback) {
      const id = w.requestIdleCallback(preloadGlobalSearch, { timeout: 5000 });
      return () => w.cancelIdleCallback?.(id);
    }
    const id = window.setTimeout(preloadGlobalSearch, 3000);
    return () => window.clearTimeout(id);
  }, []);

  if (!open && !everOpened) return null;
  return (
    <Suspense fallback={null}>
      <GlobalSearchDialog open={open} onClose={onClose} organizationId={organizationId} />
    </Suspense>
  );
}
